export default "__VITE_ASSET__B$KgaAtZ__"